export const personalHomeRoute = {
    patterns: {
        personalHome: '/me',
    },
} as const;

export const loadPersonalHomePage = async () => {
    const { PersonalHomePage } = await import('./PersonalHomePage');

    return { Component: PersonalHomePage };
};
